(function ($) {
  Drupal.behaviors.videoParallaxV1 = {
    attached: false,
    $window: $(window),
    $htmlBody: $('html, body'),
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;

      var self = this;
      var $modules = $('.js-video-parallax', context);

      $modules.each(function () {
        var $module = $(this);

        self.getDom($module);
        self.initVideoParallax($module);
      });
    },
    initVideoParallax: function ($module) {
      var self = this;
      var $local = $module;
      // Lower numbers = faster playback
      var playbackConst = 120;

      $local.nodes.videoPara.load();
      if ($local.data('playback-rate-dt')) {
        playbackConst = $local.data('playback-rate-dt');
      }
      if (self.isMobile()) {
        // Set to less offset space video mobile videos
        $local.settings.extraOffset = 1000;
        // Lower numbers = faster playback
        playbackConst = 80;
        if ($local.data('playback-rate-mob')) {
          playbackConst = $local.data('playback-rate-mob');
        }
        if ($module.data('offset-mob')) {
          $local.settings.extraOffset = $module.data('offset-mob');
        }
        // Events to capture mobile interactions for seamless video play
        self.$htmlBody.on(
          'touchstart',
          _.debounce(function () {
            self.scrollingVideo($module, playbackConst);
          })
        );
        self.$htmlBody.on(
          'touchmove',
          _.debounce(function () {
            self.scrollingVideo($module, playbackConst);
          })
        );
        self.$htmlBody.on(
          'touchend',
          _.debounce(function () {
            self.scrollingVideo($module, playbackConst);
          })
        );
        self.$window.on(
          'scroll',
          _.debounce(function () {
            self.scrollingVideo($module, playbackConst);
          })
        );
      } else {
        // Add postion sticky in desktop
        $local.nodes.pagewrapper.addClass('page-wrapper-video-parallax');
        self.$window.on(
          'scroll',
          _.debounce(function () {
            self.scrollingVideo($module, playbackConst);
          })
        );
      }
    },
    scrollingVideo: function ($module, playbackConst) {
      var self = this;
      var $local = $module;
      // Start video at frame 0
      var frameNumber = 0;
      var yOffset = 0;

      if ($local.nodes.videoPara !== undefined) {
        self.scrollingOffsets($module);
        yOffset = window.pageYOffset - $local.settings.moduleTrig;
        frameNumber = yOffset / playbackConst;
        if (frameNumber > 0 && frameNumber <= Math.round($local.nodes.videoPara.duration)) {
          $local.nodes.videoPara.currentTime = frameNumber;
          if ($local.nodes.textGroups) {
            self.showNextItem($module);
          }
        }
      }
    },
    scrollingOffsets: function ($module) {
      var $local = $module;

      $local.settings.moduleOffsetVal = $module.offset().top - $local.settings.extraOffset;
      $local.settings.moduleHeight = $local.nodes.videoContainer.height();
      $local.settings.moduleTrig = $local.settings.moduleOffsetVal + $local.settings.moduleHeight;
    },
    showNextItem: function ($module) {
      var $local = $module;
      var $item;
      var fadeTime = 500;
      var numberOfItems = $local.nodes.textGroups.length;

      // Cycle through each item, fading in and out each item
      if (
        numberOfItems > 0 &&
        Math.round($local.nodes.videoPara.currentTime) <=
          Math.round($local.nodes.videoPara.duration)
      ) {
        var currentPosition = Math.round($local.nodes.videoPara.currentTime * 100) / 100;

        for (var index = 0; index < numberOfItems; index++) {
          if (!$local.nodes.textGroups.eq(index)) {
            continue;
          }
          $item = $local.nodes.textGroups.eq(index);
          if (
            currentPosition >= $item.data('group-start') &&
            currentPosition < $item.data('group-end')
          ) {
            if ($item.hasClass('hidden')) {
              $item.removeClass('hidden');
              $item.addClass('visible');
              $item.animate({ opacity: 1 }, fadeTime);
            }
          } else if (
            currentPosition >= $item.data('group-end') ||
            currentPosition < $item.data('group-start')
          ) {
            if ($item.hasClass('visible')) {
              $item.animate({ opacity: 0 }, fadeTime);
              $item.removeClass('visible');
              $item.addClass('hidden');
            }
          }
        }
      }
    },
    isMobile: function () {
      if (Unison.fetch.now().name === 'small') {
        return true;
      }

      return false;
    },
    getDom: function ($module) {
      var $local = $module;

      $local.nodes = {};
      $local.settings = {};
      $local.nodes.videoContainer = $('.js-video-parallax-container', $local);
      $local.nodes.videoPara = $local.nodes.videoContainer.find('video')[0];
      $local.nodes.textGroups = $('.js-video-parallax-group', $local);
      $local.nodes.pagewrapper = $module.closest('.page-wrapper');
      // Default - higher the number the sooner the parallax starts
      $local.settings.extraOffset = 1300;
      $local.settings.moduleOffsetVal;
      $local.settings.moduleHeight;
      $local.settings.moduleTrig = 0;
      $local.settings.currentItem = 0;

      if ($local.data('offset-dt')) {
        $local.settings.extraOffset = $module.data('offset-dt');
      }
    }
  };
})(jQuery);
